import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
// import HomeBlog1 from "../assets/images/blog/our-blog-img-1.jpg";
// import HomeBlog2 from "../assets/images/blog/our-blog-img-2.jpg";
// import HomeBlog3 from "../assets/images/blog/our-blog-img-3.jpg";
import { Link } from "react-router-dom";
import ArrowIcon from "../assets/images/arrow-right.svg";
import ArrowIcon2 from "../assets/images/blog/arrow-down.svg";
import HeadingLines from "../assets/images/heading-lines.svg";

import { useDispatch, useSelector } from "react-redux";
import { clearMessages, fetchBlogs } from "../features/blog/blogActions";
import { toast } from "react-toastify";
import { stripHtmlTags, truncateText } from "../helpers/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function HomeBlog({categorySlug}) {
  const dispatch = useDispatch();
  const { errorMessage, blogs, loading } = useSelector((state) => state.blog);

  // State to manage pagination
  const [page, setPage] = useState(1);

  // State to store all fetched blogs
  const [allBlogs, setAllBlogs] = useState([]);

  // visible show more
  const [isVisibleShowMore, setIsVisibleShowMore] = useState(false);

  useEffect(() => {
    let blogCategoryId = "";
    if(categorySlug){ 
      blogCategoryId = categorySlug.split('-').pop();
    }
    let data = { page: page, limit: 9, blog_category_id: blogCategoryId };
    dispatch(fetchBlogs(data));
  }, [dispatch, page, categorySlug]);

  useEffect(() => {
    if (blogs?.data) {
      setAllBlogs((prevBlogs) => [...prevBlogs, ...blogs.data]);

      if (blogs?.current_page < blogs?.total_pages) {
        setIsVisibleShowMore(true);
      } else {
        setIsVisibleShowMore(false);
      }
    }
  }, [blogs]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [errorMessage, dispatch]);

  const loadMoreBlogs = () => {
    const nextPage = page + 1;
    setPage(nextPage); // Update the page number
  };

  // Reset the state when component mounts or re-mounts
  useEffect(() => {
    // Reset all jobs and page number when component loads
    setAllBlogs([]); // Clear all jobs
    setPage(1); // Reset page to 1
    setIsVisibleShowMore(false);
  }, []);

  return (
    <>
      <section className="blog-list home-blog">
        <Container>
          <Row>
            <Col md="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>Read the latest from Personal Care</h2>
                <p>
                  Senior living can often feel intimidating, but it doesn't have
                  to be. If you’ve never explored senior living, this is a great
                  starting point to learn about the basics.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="blog-list-box">
            {allBlogs.map((blog, index) => (
              <Col sm="12" md="4" className="mb-4 mb-md-0" key={blog.id}>
              <div className="home-blog-box">
                <img
                  className="home-blog-img"
                  src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${blog.image}`}
                  alt={blog.title}
                />
                <div className="home-blog-box-text">
                <Link
                    to={`/blog-details/${blog.slug}`}
                   
                  >
                  <h2>{blog.title}</h2>
                  </Link>
                  <p>{truncateText(stripHtmlTags(blog.description), 100)}</p>
                  <Link
                    to={`/blog-details/${blog.slug}`}
                    title="Read More"
                    className="custom-bttn"
                  >
                    {" "}
                    Read More{" "}
                    <img className="arrow-icon-img" src={ArrowIcon} alt="" />
                  </Link>
                </div>
              </div>
            </Col>
            ))}
          </Row>
            
          {!loading && allBlogs.length === 0 && (
            <Row>
              <Col md="12" className="text-center">
                <p>No records found.</p>
              </Col>
            </Row>
          )}

          {isVisibleShowMore && (
            <Row>
              <Col md="12">
                <Button
                  className="custom-bttn btn-center"
                  type="button"
                  disabled={loading}
                  onClick={loadMoreBlogs}
                >
                  {loading ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      size="lg"
                      className="spinner-icon"
                    />
                  ) : (
                    <>
                      Load More <img src={ArrowIcon2} alt="" />
                    </>
                  )}
                </Button>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
}
export default HomeBlog;
